import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Token key'leri portala göre çözümlenir (overwrite sorununu önler)
const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('cop31_token')}` },
});
const ultraAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('cop31_ultra_token')}` },
});

export const invitationsApi = {
  fetchCategories: () =>
    axios.get(`${API}/customer/user-categories`, authHeaders()).then((r) => r.data),

  fetchInvitations: () =>
    axios.get(`${API}/customer/invitations`, authHeaders()).then((r) => r.data),

  sendInvitation: (payload) =>
    axios.post(`${API}/customer/invitations`, payload, authHeaders()).then((r) => r.data),

  resendInvitation: (id) =>
    axios.post(`${API}/customer/invitations/${id}/resend`, {}, authHeaders()).then((r) => r.data),

  cancelInvitation: (id) =>
    axios.delete(`${API}/customer/invitations/${id}`, authHeaders()).then((r) => r.data),

  fetchSubUsers: () =>
    axios.get(`${API}/customer/sub-users`, authHeaders()).then((r) => r.data),

  toggleSubUserStatus: (id) =>
    axios.put(`${API}/customer/sub-users/${id}/toggle-status`, {}, authHeaders()).then((r) => r.data),

  // Phase 86AZ.16 — Hard-delete a sub-user (also cancels their invitation
  // server-side so the email is freed up for a fresh re-invite).
  deleteSubUser: (id) =>
    axios.delete(`${API}/customer/sub-users/${id}`, authHeaders()).then((r) => r.data),

  getInviteInfo: (token) =>
    axios.get(`${API}/invite/${token}`).then((r) => r.data),

  completeInvite: (token, payload) =>
    axios.post(`${API}/invite/${token}/complete`, payload).then((r) => r.data),

  // Ultra Admin — kendi token key'ini kullanır
  fetchAdminCategories: () =>
    axios.get(`${API}/ultra-admin/user-categories`, ultraAuthHeaders()).then((r) => r.data),

  createCategory: (name) =>
    axios.post(`${API}/ultra-admin/user-categories`, { name }, ultraAuthHeaders()).then((r) => r.data),

  updateCategory: (id, name) =>
    axios.put(`${API}/ultra-admin/user-categories/${id}`, { name }, ultraAuthHeaders()).then((r) => r.data),

  deleteCategory: (id) =>
    axios.delete(`${API}/ultra-admin/user-categories/${id}`, ultraAuthHeaders()).then((r) => r.data),
};
